export const simplifiedFLowEvents = {
  claim_for_delay_clicked_dy: {
    event: `optimize.claim_for_delay_clicked_dy`,
    eventAction: "EnquiryStepComplete",
    eventLabel: "delayed:continue_claim",
    eventCategory: "ClaimProcess",
  },
  claim_for_other_reason_clicked_dy: {
    event: `optimize.claim_for_other_reason_clicked_dy`,
    eventAction: "EnquiryStepComplete",
    eventLabel: "delayed:other_reason",
    eventCategory: "ClaimProcess",
  },
  claim_for_cancellation_clicked_cx: {
    event: `optimize.claim_for_cancellation_clicked_cx`,
    eventAction: "EnquiryStepComplete",
    eventLabel: "canceled:continue_claim",
    eventCategory: "ClaimProcess",
  },
  claim_for_other_reason_clicked_cx: {
    event: `optimize.claim_for_other_reason_clicked_cx`,
    eventAction: "EnquiryStepComplete",
    eventLabel: "canceled:other_reason",
    eventCategory: "ClaimProcess",
  },
};
